export async function fetcher(...args) {
    const response = await fetch(...args);
    let body = null;
    console.log(response.headers.get('Content-Type'));
    if (response.headers.get('Content-Type').includes('application/json')) {
        body = await response.json();
    }
    return {
        response,
        body,
    };
}
